import React, { useState, useEffect } from 'react';
import axios from 'axios';

// Logos y encabezados
import logoHGW from './assets/recursos vertical/SVG/logos G-H.svg';
import logoAniversario from './assets/Logo-3_5to-aniversario.png';
import lineaDorada from './assets/recursos vertical/Recurso 55.png';
import textoMentoriaExclusiva from './assets/recursos vertical/solo-mentoria-exclusiva.png';
import textoRangosDeHonor from './assets/recursos vertical/solo-rangos-de-honor.png';
import textoCumbreInternacional from './assets/recursos vertical/cumbre internaciona.png';
import textoPlataDiamante from './assets/recursos vertical/de plata a diamante.png';

// Edificios específicos: Desktop panorámico recortado (edificio-desktop-optimizado.png) y Móvil (edificio.png)
import edificioDesktop from './assets/edificio-desktop-optimizado.png';
import edificioMovil from './assets/recursos vertical/edificio.png';

import textoExclusiva from './assets/recursos vertical/Recurso 80.png'; // ¡TU PARTICIPACIÓN ES EXCLUSIVA!
import cuposLimitadosImg from './assets/recursos vertical/Recurso 62.png'; // ¡CUPOS LIMITADOS!
import cuposAgotadosImg from './assets/recursos vertical/cupos agotados.png'; // Modal Cupos Agotados

// Pines de honor

import plataPin from './assets/Rangos/PLATA.png';
import oroPin from './assets/Rangos/ORO.png';
import platinoPin from './assets/Rangos/PLATINUM.png';

import diamante1 from './assets/Rangos/DIAMANTE1.png';
import diamante2 from './assets/Rangos/DIAMANTE 1.png';
import diamante3 from './assets/Rangos/DIAMANTE 2.png';
import diamante4 from './assets/Rangos/DIAMANTE 3.png';
import diamante5 from './assets/Rangos/DIAMANTE 4.png';
import diamante6 from './assets/Rangos/DIAMANTE 5.png';
import diamante7 from './assets/Rangos/DIAMANTE 6.png';
import diamante8 from './assets/Rangos/DIAMANTE 7.png';


import da1 from './assets/Rangos/DA 1.png';
import da2 from './assets/Rangos/DA 2.png';
import da3 from './assets/Rangos/DA 3.png';
import da4 from './assets/Rangos/DA 4.png';
import da5 from './assets/Rangos/DA 5.png';

// Iconos SVG
import iconoCalendario from './assets/recursos vertical/SVG/calendario.svg';
import iconoReloj from './assets/recursos vertical/SVG/reloj.svg';
import iconoUbicacion from './assets/recursos vertical/SVG/ubicacion.svg';
import iconoSubir from './assets/recursos vertical/SVG/icono subir.svg';
import iconoBoleta from './assets/recursos vertical/SVG/boleta.svg';
import iconoCamara from './assets/icono camara.png';
import botonEnviarImg from './assets/boton-enviar-.png';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5070/api';

const diamantes = [
  { img: diamante1, label: 'Diamante 1★' },
  { img: diamante2, label: 'Diamante 2★' },
  { img: diamante3, label: 'Diamante 3★' },
  { img: diamante4, label: 'Diamante 4★' },
  { img: diamante5, label: 'Diamante 5★' },
  { img: diamante6, label: 'Diamante 6★' },
  { img: diamante7, label: 'Diamante 7★' },
  { img: diamante8, label: 'Diamante 8★' },
];

const diamantesAzul = [
  { img: da1, label: 'Diamante Azul 1★' },
  { img: da2, label: 'Diamante Azul 2★' },
  { img: da3, label: 'Diamante Azul 3★' },
  { img: da4, label: 'Diamante Azul 4★' },
  { img: da5, label: 'Diamante Azul 5★' },
];

function App() {
  // Modal de registro y estado de éxito
  const [showModal, setShowModal] = useState(false);
  const [successRegistered, setSuccessRegistered] = useState(false);

  // Límite de cupos (1900 registros)
  const [cuposAgotados, setCuposAgotados] = useState(false);

  // Form State
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    tipo_documento: 'Cédula de Ciudadanía',
    numero_documento: '',
    usuario_hgw: '',
    numero_celular: '',
    ciudad: '',
    numero_boleta: ''
  });

  // Configuración dinámica desde el admin (ocultar/activar boleta)
  const [boletaConfig, setBoletaConfig] = useState({
    solicitar_boleta: false,
    boleta_obligatoria: false
  });

  const [boletaFile, setBoletaFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Función para consultar la cantidad actual de registros y validar cupos
  const checkCupos = async () => {
    try {
      // Intentar primero con el endpoint optimizado /cupos-status
      const res = await axios.get(`${API_BASE_URL}/cupos-status`);
      if (res.data) {
        const count = res.data.total ?? 0;
        if (count >= 1900 || res.data.cuposAgotados) {
          setCuposAgotados(true);
          setShowModal(false); // Cierra modal de registro si estaba abierto
        }
      }
    } catch (e) {
      // Fallback a /registro si /cupos-status aún no estuviera disponible
      try {
        const resReg = await axios.get(`${API_BASE_URL}/registro`);
        if (resReg.data) {
          const count = resReg.data.total ?? (Array.isArray(resReg.data.data) ? resReg.data.data.length : 0);
          if (count >= 1900) {
            setCuposAgotados(true);
            setShowModal(false);
          }
        }
      } catch (errFallback) {
        console.log('Error verificando cupos:', errFallback.message);
      }
    }
  };

  // Cargar configuración de campos del panel admin y verificar cupos
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/configuracion`);
        if (res.data?.config) {
          const cfg = res.data.config;
          setBoletaConfig({
            solicitar_boleta: cfg.solicitar_boleta === 'true' || cfg.solicitar_boleta === true,
            boleta_obligatoria: cfg.boleta_obligatoria === 'true' || cfg.boleta_obligatoria === true
          });
        }
      } catch (e) {
        console.log('Usando configuración por defecto de formulario');
      }
    };

    fetchConfig();
    checkCupos();

    // Consulta periódica cada 15 segundos para mantener actualizado el estado de cupos
    const interval = setInterval(checkCupos, 15000);
    return () => clearInterval(interval);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBoletaFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    // Si los cupos ya están agotados, bloquear
    if (cuposAgotados) {
      return;
    }

    // Validación de campos base obligatorios
    if (
      !formData.nombre.trim() ||
      !formData.apellido.trim() ||
      !formData.tipo_documento ||
      !formData.numero_documento.trim() ||
      !formData.usuario_hgw.trim() ||
      !formData.numero_celular.trim() ||
      !formData.ciudad.trim()
    ) {
      setErrorMessage('Por favor complete todos los campos obligatorios (*).');
      return;
    }

    // Validación condicional de boleta solo si el admin la exige como obligatoria
    if (boletaConfig.solicitar_boleta && boletaConfig.boleta_obligatoria && !formData.numero_boleta.trim()) {
      setErrorMessage('Por favor ingrese el número de su boleta de ingreso.');
      return;
    }

    try {
      setIsSubmitting(true);
      const dataToSend = new FormData();
      dataToSend.append('nombre', formData.nombre);
      dataToSend.append('apellido', formData.apellido);
      dataToSend.append('tipo_documento', formData.tipo_documento);
      dataToSend.append('numero_documento', formData.numero_documento);
      dataToSend.append('usuario_hgw', formData.usuario_hgw);
      dataToSend.append('numero_celular', formData.numero_celular);
      dataToSend.append('ciudad', formData.ciudad);
      dataToSend.append('numero_boleta', formData.numero_boleta);

      if (boletaFile) {
        dataToSend.append('foto_boleta', boletaFile);
      }

      await axios.post(`${API_BASE_URL}/registro`, dataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      setSuccessRegistered(true);
      setFormData({
        nombre: '',
        apellido: '',
        tipo_documento: 'Cédula de Ciudadanía',
        numero_documento: '',
        usuario_hgw: '',
        numero_celular: '',
        ciudad: '',
        numero_boleta: ''
      });
      setBoletaFile(null);
      setPreviewUrl(null);
      checkCupos();
    } catch (err) {
      console.error('Error enviando formulario:', err);
      if (err.response?.status === 403 || err.response?.data?.cuposAgotados) {
        setCuposAgotados(true);
        setShowModal(false);
        return;
      }
      const msg = err.response?.data?.message || 'Error al procesar el registro. Intente nuevamente.';
      setErrorMessage(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  const openRegisterModal = () => {
    if (cuposAgotados) return;
    setErrorMessage('');
    setShowModal(true);
  };

  const closeRegisterModal = () => {
    setShowModal(false);
    if (successRegistered) {
      setSuccessRegistered(false);
    }
  };

  return (
    <div
      className="min-h-screen w-full bg-[#02180f] font-barlow text-white relative selection:bg-[#d4af37] selection:text-green-950 overflow-x-hidden flex flex-col justify-between bg-landing-responsive"
    >
      {/* ========================================================================= */}
      {/* EDIFICIO PANORÁMICO DESKTOP: Ocupa el 100% a lo ancho y estrechado 20% alto */}
      {/* ========================================================================= */}
      <div className="hidden lg:block absolute left-0 right-0 w-full bottom-[13%] z-0 pointer-events-none select-none">
        <img
          src={edificioDesktop}
          alt="Ágora Bogotá Panorámico"
          className="w-full h-auto object-fill object-bottom block transform scale-y-[0.70] origin-bottom"
        />
      </div>

      {/* ============================================================ */}
      {/* CUERPO PRINCIPAL: Layout Rangos de Honor                     */}
      {/* ============================================================ */}
      <main className="relative z-10 w-full max-w-[1440px] mx-auto px-3 sm:px-6 lg:px-8 pt-3 sm:pt-6 lg:pt-[2vh] pb-3 md:pb-4 flex-grow flex flex-col justify-start overflow-x-hidden">

        {/* Layout Desktop Horizontal (2 columnas) / Móvil Centrado Vertical */}
        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-0 lg:gap-6 xl:gap-8 items-start lg:pt-[1vh]">

          {/* ============================================================ */}
          {/* COLUMNA IZQUIERDA (Desktop) / SECCIÓN SUPERIOR (Móvil)       */}
          {/* ============================================================ */}
          <div className="lg:col-span-6 xl:col-span-6 flex flex-col items-center justify-center text-center px-1 sm:px-0">

            {/* 1. Logos HGW y GREEN WORLD */}
            <div className="flex justify-center mb-1 sm:mb-2 transition-transform hover:scale-105 duration-300">
              <img
                src={logoHGW}
                alt="HGW Logo"
                className="h-14 sm:h-16 md:h-18 lg:h-[72px] xl:h-[84px] object-contain drop-shadow-[0_4px_20px_rgba(0,0,0,0.95)]"
              />
            </div>

            {/* 2. Subtítulo: CUMBRE INTERNACIONAL DE LIDERAZGO */}
            <div className="w-full flex items-center justify-center my-0 sm:my-1 px-0">
              <img
                src={textoCumbreInternacional}
                alt="CUMBRE INTERNACIONAL DE LIDERAZGO"
                className="w-[88%] max-w-[290px] sm:max-w-[340px] md:max-w-[360px] lg:max-w-[260px] h-auto object-contain drop-shadow-[0_2px_10px_rgba(0,0,0,0.9)]"
              />
            </div>

            {/* En DESKTOP: RANGOS DE HONOR que se posa sobre el edificio */}
            <div className="lg:flex w-full lg:max-w-[240px] xl:max-w-[300px] justify-center lg:mt-[0vh] xl:mt-[0vh] mb-0">
              <img
                src={textoRangosDeHonor}
                alt="RANGOS DE HONOR"
                className="w-full h-auto object-contain drop-shadow-[0_10px_30px_rgba(0,0,0,0.95)] animate-pulse-gold"
              />
            </div>

            {/* 3. Texto: De Plata a Diamante (en Desktop sobre la fachada del edificio, tal como en la imagen de referencia) */}
            <div className="w-full flex items-center justify-center -mt-1 sm:-mt-1.5 lg:-mt-2 px-0">
              <img
                src={textoPlataDiamante}
                alt="DE PLATA A DIAMANTE"
                className="w-[72%] max-w-[270px] sm:max-w-[320px] md:max-w-[360px] lg:max-w-[380px] h-auto object-contain drop-shadow-[0_2px_10px_rgba(0,0,0,0.9)]"
              />
            </div>

            {/* Fotografía de Ágora Bogotá Móvil (Como en la imagen de referencia, nítido y completo sobre la tarjeta) */}
            <div className="lg:hidden relative w-full flex justify-center overflow-hidden my-1">
              <img
                src={edificioMovil}
                alt="Ágora Bogotá - Móvil"
                className="w-full max-w-[380px] h-auto object-contain block drop-shadow-[0_15px_35px_rgba(0,0,0,0.85)]"
              />
            </div>
          </div>

          {/* ============================================================ */}
          {/* COLUMNA DERECHA (Desktop) / TARJETA Y ACCIONES (Móvil)        */}
          {/* ============================================================ */}
          <div className="lg:col-span-6 xl:col-span-6 flex flex-col items-center justify-center w-full z-20 -mt-[35%] lg:mt-0 lg:translate-x-[10%] px-1 sm:px-4 lg:px-0">
            <div
              className="w-full max-w-[410px] sm:max-w-[500px] lg:max-w-[560px] rounded-2xl sm:rounded-3xl p-3 sm:p-5 md:p-6 border-2 border-[#d4af37]/90 relative overflow-hidden backdrop-blur-xl shadow-[0_25px_60px_rgba(0,0,0,0.92)] gold-glow-box bg-[#022116]/95 transition-all"
            >
              {/* Título de la Tarjeta: ¡TU PARTICIPACIÓN ES EXCLUSIVA! */}
              <div className="flex flex-col items-center text-center mb-1 sm:mb-2">
                <img
                  src={textoExclusiva}
                  alt="¡Tu participación es exclusiva!"
                  className="w-full max-w-[270px] sm:max-w-[340px] md:max-w-[380px] object-contain drop-shadow-[0_4px_12px_rgba(0,0,0,0.9)]"
                />
              </div>

              {/* ============================================================ */}
              {/* GRUPO DE PINES DE HONOR (Plata, Oro, Platino, Diamantes, DA) */}
              {/* ============================================================ */}
              <div className="space-y-2 sm:space-y-3 my-1.5 sm:my-2">
                {/* Nivel 1: Plata, Oro, Platinum */}
                <div className="flex items-center justify-center gap-2 sm:gap-4">
                  <div className="flex flex-col items-center group">
                    <img
                      src={plataPin}
                      alt="Pin Plata"
                      className="w-12 sm:w-16 md:w-20 object-contain drop-shadow-[0_6px_14px_rgba(0,0,0,0.8)] transform group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="flex flex-col items-center group">
                    <img
                      src={oroPin}
                      alt="Pin Oro"
                      className="w-12 sm:w-16 md:w-20 object-contain drop-shadow-[0_6px_14px_rgba(0,0,0,0.8)] transform group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="flex flex-col items-center group">
                    <img
                      src={platinoPin}
                      alt="Pin Platinum"
                      className="w-12 sm:w-16 md:w-20 object-contain drop-shadow-[0_6px_14px_rgba(0,0,0,0.8)] transform group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                </div>

                {/* Nivel 2: Fila de Diamantes (1 a 8 Estrellas como en la imagen) */}
                <div className="flex items-center justify-center gap-1 sm:gap-1.5 px-0.5">
                  {diamantes.map((pin, idx) => (
                    <div key={idx} className="flex-shrink-0 group">
                      <img
                        src={pin.img}
                        alt={pin.label}
                        title={pin.label}
                        className="w-7 sm:w-9 md:w-11 object-contain drop-shadow-[0_4px_10px_rgba(0,0,0,0.7)] transform group-hover:scale-125 transition-transform duration-300 cursor-pointer"
                      />
                    </div>
                  ))}
                </div>

                {/* Nivel 3: Fila de Diamantes Azules (1 a 5 Estrellas) */}
                <div className="flex items-center justify-center gap-1.5 sm:gap-2.5 px-0.5">
                  {diamantesAzul.map((pin, idx) => (
                    <div key={idx} className="flex-shrink-0 group">
                      <img
                        src={pin.img}
                        alt={pin.label}
                        title={pin.label}
                        className="w-10 sm:w-12 md:w-14 object-contain drop-shadow-[0_6px_14px_rgba(0,0,0,0.8)] transform group-hover:scale-120 transition-transform duration-300 cursor-pointer"
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* ============================================================ */}
              {/* BARRA INFORMATIVA: Fecha, Hora y Lugar                        */}
              {/* ============================================================ */}
              <div className="mt-2.5 sm:mt-3 pt-2 sm:pt-2.5 border-t border-[#d4af37]/40 flex items-center justify-between gap-1 sm:gap-3 text-left">
                {/* Fecha */}
                <div className="flex items-center space-x-1.5 sm:space-x-2.5 flex-1 justify-center sm:justify-start">
                  <img src={iconoCalendario} alt="Fecha" className="w-5 sm:w-7 h-5 sm:h-7 object-contain flex-shrink-0" />
                  <div className="leading-tight">
                    <span className="block text-[10px] sm:text-xs text-white font-semibold uppercase">27 de</span>
                    <span className="block text-xs sm:text-sm md:text-base font-extrabold text-white tracking-wider">NOVIEMBRE 2026</span>
                  </div>
                </div>

                {/* Línea Divisoria Vertical */}
                <div className="w-[1px] h-6 sm:h-8 bg-[#d4af37]/50" />

                {/* Hora */}
                <div className="flex items-center space-x-1.5 sm:space-x-2 flex-1 justify-center">
                  <img src={iconoReloj} alt="Hora" className="w-5 sm:w-7 h-5 sm:h-7 object-contain flex-shrink-0" />
                  <div className="leading-tight text-left">
                    <span className="block text-[11px] sm:text-xs md:text-sm font-extrabold text-white">9:00 a.m.</span>
                    <span className="block text-[11px] sm:text-xs md:text-sm font-extrabold text-white">3:00 p.m.</span>
                  </div>
                </div>

                {/* Línea Divisoria Vertical */}
                <div className="w-[1px] h-6 sm:h-8 bg-[#d4af37]/50" />

                {/* Lugar */}
                <div className="flex items-center space-x-1.5 sm:space-x-2 flex-1 justify-center sm:justify-start">
                  <img src={iconoUbicacion} alt="Lugar" className="w-4 sm:w-6 h-5 sm:h-7 object-contain flex-shrink-0" />
                  <div className="leading-tight">
                    <span className="block text-[11px] sm:text-xs md:text-sm font-extrabold italic text-white tracking-wide">Ágora</span>
                    <span className="block text-[9px] sm:text-[11px] text-gray-300 font-medium">Bogotá - Colombia</span>
                  </div>
                </div>
              </div>

            </div>

            {/* BOTÓN REGISTRARSE: Ubicado debajo de la tarjeta de rangos con el estilo exacto de la referencia */}
            <div className="w-full max-w-[410px] sm:max-w-[500px] lg:max-w-[560px] flex justify-center mt-3 sm:mt-4">
              <button
                onClick={openRegisterModal}
                disabled={cuposAgotados}
                className={`w-full py-2.5 sm:py-3 px-6 rounded-lg sm:rounded-xl font-bold text-xs sm:text-sm uppercase tracking-wider transition-all flex items-center justify-center space-x-2 border ${
                  cuposAgotados
                    ? 'bg-neutral-800 text-neutral-400 border-neutral-700 cursor-not-allowed opacity-60 pointer-events-none'
                    : 'text-neutral-900 bg-gradient-to-r from-[#ffe08a] via-[#ffd677] to-[#d4af37] hover:brightness-110 shadow-[0_0_25px_rgba(218,165,32,0.5)] transform hover:scale-[1.01] active:scale-95 cursor-pointer border-[#fff2b2]/40'
                }`}
              >
                <span>{cuposAgotados ? 'CUPOS AGOTADOS' : 'REGISTRARSE AHORA'}</span>
                {!cuposAgotados && <span className="text-base sm:text-lg">→</span>}
              </button>
            </div>

            {/* BANNER INFERIOR: ¡CUPOS LIMITADOS! debajo del botón en móvil */}
            <div className="w-full flex lg:hidden justify-center items-center mt-2.5 sm:mt-3">
              <img
                src={cuposLimitadosImg}
                alt="¡CUPOS LIMITADOS!"
                className="w-full max-w-[270px] sm:max-w-[340px] md:max-w-[420px] object-contain drop-shadow-[0_8px_20px_rgba(0,0,0,0.9)] animate-pulse"
              />
            </div>
          </div>


        </div>

        {/* BANNER INFERIOR DESKTOP: Centrado abajo de toda la pantalla con mayor tamaño */}
        <div className="hidden lg:flex w-full justify-center items-center mt-auto pt-4 pb-2 z-20">
          <img
            src={cuposLimitadosImg}
            alt="¡CUPOS LIMITADOS!"
            className="w-full max-w-[520px] xl:max-w-[620px] object-contain drop-shadow-[0_10px_25px_rgba(0,0,0,0.95)] animate-pulse"
          />
        </div>

      </main>

      {/* ========================================================================= */}
      {/* MODAL OFICIAL: FORMULARIO DE REGISTRO ESCALADO CON FONDO OFICIAL           */}
      {/* ========================================================================= */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-6 overflow-y-auto bg-black/85 backdrop-blur-md animate-fadeIn">
          {/* Modal Container: Más escalado (max-w-[720px]), usa el mismo fondo oficial .bg-landing-responsive */}
          <div
            className="relative w-full max-w-[720px] my-auto rounded-3xl p-6 sm:p-10 md:p-12 border-2 border-[#d4af37] shadow-[0_25px_70px_rgba(0,0,0,0.95)] gold-glow-box text-white bg-landing-responsive overflow-hidden"
          >
            {/* Capa de contraste interna para legibilidad superior */}
            <div className="absolute inset-0 bg-[#021f15]/90 sm:bg-[#021f15]/85 backdrop-blur-sm pointer-events-none" />

            {/* Botón Cerrar (X) */}
            <button
              onClick={closeRegisterModal}
              className="absolute top-5 right-5 w-10 h-10 rounded-full bg-[#011910] border border-[#d4af37]/80 text-[#ffd677] hover:text-white hover:bg-red-950/80 transition-all flex items-center justify-center text-xl font-bold shadow-lg cursor-pointer z-30"
              title="Cerrar"
            >
              ✕
            </button>

            {/* Contenido relativo por encima de las capas de fondo */}
            <div className="relative z-10">
              {/* Estado 1: Formulario de Registro */}
              {!successRegistered ? (
                <>
                  {/* Cabecera del Modal con Título Institucional */}
                  <div className="text-center mb-6 sm:mb-8 pr-6">
                    <div className="inline-flex items-center space-x-2 px-4 py-1.5 rounded-full border border-[#d4af37]/70 bg-[#011f15]/90 text-[#ffd677] text-xs sm:text-sm uppercase tracking-widest font-bold mb-3 shadow-inner">
                      <span>Ágora Bogotá</span>
                      <span>•</span>
                      <span>27 Noviembre 2026</span>
                    </div>
                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold uppercase tracking-widest text-transparent bg-clip-text bg-gradient-to-r from-[#ffe08a] via-[#ffd677] to-[#d4af37] drop-shadow-md">
                      REGISTRO DE ASISTENCIA
                    </h2>
                    <p className="text-sm sm:text-base text-gray-200 mt-2 font-medium">
                      Cumbre Internacional de Liderazgo Rangos De Honor
                    </p>
                  </div>

                  {errorMessage && (
                    <div className="mb-5 p-3.5 bg-red-950/90 border border-red-500 rounded-xl text-red-200 text-sm text-center shadow-lg">
                      {errorMessage}
                    </div>
                  )}

                  <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
                    {/* Nombre y Apellido */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
                      <div>
                        <label className="block text-sm sm:text-base text-gray-200 mb-1.5 font-semibold">Nombre*</label>
                        <input
                          type="text"
                          name="nombre"
                          value={formData.nombre}
                          onChange={handleChange}
                          required
                          placeholder="Ej. Carlos"
                          className="w-full bg-[#011a11]/95 border border-[#1b6b4b] focus:border-[#d4af37] focus:outline-none focus:ring-2 focus:ring-[#d4af37]/60 rounded-xl px-4 py-3 text-base text-white placeholder-gray-500 transition-all shadow-inner"
                        />
                      </div>
                      <div>
                        <label className="block text-sm sm:text-base text-gray-200 mb-1.5 font-semibold">Apellido*</label>
                        <input
                          type="text"
                          name="apellido"
                          value={formData.apellido}
                          onChange={handleChange}
                          required
                          placeholder="Ej. Gómez"
                          className="w-full bg-[#011a11]/95 border border-[#1b6b4b] focus:border-[#d4af37] focus:outline-none focus:ring-2 focus:ring-[#d4af37]/60 rounded-xl px-4 py-3 text-base text-white placeholder-gray-500 transition-all shadow-inner"
                        />
                      </div>
                    </div>

                    {/* Tipo de Documento y Nro. Documento */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
                      <div>
                        <label className="block text-sm sm:text-base text-gray-200 mb-1.5 font-semibold">Tipo de Documento*</label>
                        <select
                          name="tipo_documento"
                          value={formData.tipo_documento}
                          onChange={handleChange}
                          required
                          className="w-full bg-[#011a11]/95 border border-[#1b6b4b] focus:border-[#d4af37] focus:outline-none focus:ring-2 focus:ring-[#d4af37]/60 rounded-xl px-4 py-3 text-base text-white transition-all cursor-pointer shadow-inner"
                        >
                          <option value="Cédula de Ciudadanía">Cédula de Ciudadanía</option>
                          <option value="Cédula de Extranjería">Cédula de Extranjería</option>
                          <option value="Pasaporte">Pasaporte</option>
                          <option value="DNI">DNI</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm sm:text-base text-gray-200 mb-1.5 font-semibold">Nro. Documento de Identidad*</label>
                        <input
                          type="text"
                          name="numero_documento"
                          value={formData.numero_documento}
                          onChange={handleChange}
                          required
                          placeholder="1023456789"
                          className="w-full bg-[#011a11]/95 border border-[#1b6b4b] focus:border-[#d4af37] focus:outline-none focus:ring-2 focus:ring-[#d4af37]/60 rounded-xl px-4 py-3 text-base text-white placeholder-gray-500 transition-all shadow-inner"
                        />
                      </div>
                    </div>

                    {/* Usuario Registrado en HGW y Teléfono en dos columnas */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
                      <div>
                        <label className="block text-sm sm:text-base text-gray-200 mb-1.5 font-semibold">Usuario registrado en HGW*</label>
                        <input
                          type="text"
                          name="usuario_hgw"
                          value={formData.usuario_hgw}
                          onChange={handleChange}
                          required
                          placeholder="Tu usuario en HGW"
                          className="w-full bg-[#011a11]/95 border border-[#1b6b4b] focus:border-[#d4af37] focus:outline-none focus:ring-2 focus:ring-[#d4af37]/60 rounded-xl px-4 py-3 text-base text-white placeholder-gray-500 transition-all shadow-inner"
                        />
                      </div>
                      <div>
                        <label className="block text-sm sm:text-base text-gray-200 mb-1.5 font-semibold">Número de celular*</label>
                        <input
                          type="tel"
                          name="numero_celular"
                          value={formData.numero_celular}
                          onChange={handleChange}
                          required
                          placeholder="+57 300 123 4567"
                          className="w-full bg-[#011a11]/95 border border-[#1b6b4b] focus:border-[#d4af37] focus:outline-none focus:ring-2 focus:ring-[#d4af37]/60 rounded-xl px-4 py-3 text-base text-white placeholder-gray-500 transition-all shadow-inner"
                        />
                      </div>
                    </div>

                    {/* Ciudad de Residencia / Origen */}
                    <div>
                      <label className="block text-sm sm:text-base text-gray-200 mb-1.5 font-semibold">Ciudad*</label>
                      <input
                        type="text"
                        name="ciudad"
                        value={formData.ciudad}
                        onChange={handleChange}
                        required
                        placeholder="Ej. Bogotá, Medellín, Cali, etc."
                        className="w-full bg-[#011a11]/95 border border-[#1b6b4b] focus:border-[#d4af37] focus:outline-none focus:ring-2 focus:ring-[#d4af37]/60 rounded-xl px-4 py-3 text-base text-white placeholder-gray-500 transition-all shadow-inner"
                      />
                    </div>

                    {/* CAMPOS OPCIONALES DE BOLETA (Activables dinámicamente desde el panel Admin) */}
                    {boletaConfig.solicitar_boleta && (
                      <div className="space-y-4 pt-1 animate-fadeIn">
                        {/* Número de Boleta */}
                        <div>
                          <label className="flex items-center justify-between text-sm sm:text-base text-gray-200 mb-1.5 font-semibold">
                            <span>Número de boleta {boletaConfig.boleta_obligatoria ? '*' : '(Opcional)'}</span>
                            <span className="text-xs text-[#ffd677] font-normal">Identificador de tu boleta física o digital</span>
                          </label>
                          <input
                            type="text"
                            name="numero_boleta"
                            value={formData.numero_boleta}
                            onChange={handleChange}
                            required={boletaConfig.boleta_obligatoria}
                            placeholder="Ej. B-001234 o número impreso"
                            className="w-full bg-[#011a11]/95 border border-[#1b6b4b] focus:border-[#d4af37] focus:outline-none focus:ring-2 focus:ring-[#d4af37]/60 rounded-xl px-4 py-3 text-base text-white placeholder-gray-500 transition-all shadow-inner font-mono"
                          />
                        </div>

                        {/* Subir Fotografía de Boleta */}
                        <div className="border border-[#1b6b4b] bg-[#011a11]/90 rounded-2xl p-4 sm:p-5 flex items-center justify-between gap-4 hover:border-[#d4af37]/80 transition-all shadow-inner">
                          <div className="flex-1">
                            <p className="text-sm sm:text-base font-bold text-white mb-1">
                              Fotografía de la boleta {boletaConfig.boleta_obligatoria ? '*' : '(Opcional)'}:
                            </p>
                            <p className="text-xs sm:text-sm text-gray-300 leading-snug">
                              Carga la foto de tu boleta para confirmar tu pase exclusivo a Ágora Bogotá.
                            </p>
                          </div>
                          <label className="cursor-pointer flex-shrink-0 relative group">
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleFileChange}
                              className="hidden"
                              required={boletaConfig.boleta_obligatoria && !boletaFile}
                            />
                            <div className="w-16 h-14 sm:w-20 sm:h-16 rounded-xl border-2 border-[#d4af37] flex items-center justify-center bg-[#011f15] hover:bg-[#023121] transition-all transform group-hover:scale-105 shadow-md">
                              {previewUrl ? (
                                <img src={previewUrl} alt="Boleta cargada" className="w-full h-full object-cover rounded-xl" />
                              ) : (
                                <img src={iconoCamara} alt="Subir fotografía" className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
                              )}
                            </div>
                          </label>
                        </div>

                        {boletaFile && (
                          <div className="text-sm text-[#ffd677] flex items-center justify-between px-1">
                            <span className="truncate">✓ Foto cargada: {boletaFile.name}</span>
                            <button
                              type="button"
                              onClick={() => { setBoletaFile(null); setPreviewUrl(null); }}
                              className="text-red-400 hover:text-red-300 underline ml-2 whitespace-nowrap font-semibold cursor-pointer"
                            >
                              Quitar
                            </button>
                          </div>
                        )}
                      </div>
                    )}

                    <p className="text-xs text-gray-400">*Campos obligatorios para confirmar su ingreso a la mentoría.</p>

                    {/* Botón Enviar Registro */}
                    <div className="pt-3 flex justify-center">
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full max-w-[360px] transform hover:scale-105 active:scale-95 transition-all disabled:opacity-60 focus:outline-none cursor-pointer"
                      >
                        {isSubmitting ? (
                          <div className="w-full py-4 bg-gradient-to-r from-[#b38938] via-[#e5c158] to-[#b38938] text-green-950 font-black text-lg sm:text-xl rounded-2xl text-center shadow-2xl animate-pulse">
                            PROCESANDO REGISTRO...
                          </div>
                        ) : (
                          <img
                            src={botonEnviarImg}
                            alt="ENVIAR REGISTRO"
                            className="w-full h-auto object-contain cursor-pointer drop-shadow-[0_8px_20px_rgba(218,165,32,0.5)]"
                          />
                        )}
                      </button>
                    </div>
                  </form>
                </>
              ) : (
                /* Estado 2: Mensaje de Registro Exitoso */
                <div className="text-center py-8 px-4 space-y-5">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full border-2 border-[#d4af37] bg-[#012b1c] text-[#ffd677] flex items-center justify-center text-4xl sm:text-5xl mx-auto shadow-[0_0_35px_rgba(218,165,32,0.6)]">
                    ✓
                  </div>
                  <h3 className="text-3xl sm:text-4xl font-extrabold uppercase text-[#ffd677] tracking-wider">
                    ¡REGISTRO CONFIRMADO!
                  </h3>
                  <p className="text-base sm:text-lg text-gray-200 max-w-[480px] mx-auto leading-relaxed">
                    Tus datos han sido registrados exitosamente para la
                  </p>
                  <p className="text-base sm:text-lg text-gray-200 max-w-[480px] mx-auto leading-relaxed">
                    <strong>Cumbre Internacional de Liderazgo Rangos De Honor</strong> en <strong>Ágora Bogotá</strong>.
                  </p>
                  <div className="p-4 bg-[#011a11]/90 border border-[#1b6b4b] rounded-2xl text-sm sm:text-base text-gray-300 max-w-[420px] mx-auto">
                    <p>📅 Fecha: <strong>27 de Noviembre 2026</strong></p>
                    <p>⏰ Horario: <strong>9:00 a.m. - 3:00 p.m.</strong></p>
                    <p>📍 Lugar: <strong>Ágora Bogotá - Colombia</strong></p>
                  </div>
                  <div className="pt-4">
                    <button
                      onClick={() => setSuccessRegistered(false)}
                      className="w-full max-w-[320px] py-3.5 px-6 rounded-2xl font-extrabold text-green-950 text-base uppercase tracking-wider bg-gradient-to-r from-[#ffe08a] via-[#ffd677] to-[#d4af37] hover:brightness-110 shadow-lg cursor-pointer transform hover:scale-105 active:scale-95 transition-all"
                    >
                      REGISTRAR OTRO ASISTENTE
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ========================================================================= */}
      {/* MODAL TRANSPARENTE DE CUPOS AGOTADOS (1900 REGISTROS ALCANZADOS)          */}
      {/* Inhabilita navegación y registro con solo la imagen oficial              */}
      {/* ========================================================================= */}
      {cuposAgotados && (
        <div
          id="modal-cupos-agotados"
          className="fixed inset-0 z-[9999] flex items-center justify-center p-3 sm:p-6 bg-black/75 backdrop-blur-sm select-none"
          style={{ touchAction: 'none' }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative flex items-center justify-center max-w-[92vw] sm:max-w-[85vw] md:max-w-[720px] max-h-[92vh] animate-fadeIn pointer-events-auto">
            <img
              src={cuposAgotadosImg}
              alt="Cupos Agotados"
              className="w-full h-auto max-h-[88vh] object-contain drop-shadow-[0_15px_40px_rgba(0,0,0,0.95)]"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
